<template>
  <v-container id="user-list">
    <v-row>
      <v-col>Cadastro de usuário</v-col>
      <v-col class="text-right">
        <v-btn outlined color="primary" class="ml-3" :to="'/usuario'">
          Voltar para Lista de Usuários
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Nome do usuário*"
          name="nome"
          type="text"
          required
          v-model="usuario.nome"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <app-group-combobox
          :filter="usuario"
          :idsToFilter="groupsHierarquia"
          :placeholderName="'Grupo*'"
        >
        </app-group-combobox>
      </v-col>
      <v-col>
        <v-checkbox
          v-model="usuario.ats"
          id="ats"
          color="primary"
          label="Atua como ATS"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="E-mail*"
          name="email"
          type="email"
          required
          v-model="usuario.email"
          validate-on-blur
          :error-messages="emailErrors"
          @blur="(v) => verifyEmail(v.target.value)"
        ></v-text-field>
      </v-col>
    </v-row>
    <template v-if="maisdados">
      <v-row>
        <v-col>
          <v-text-field
            label="CPF"
            name="cpf"
            type="text"
            required
            v-mask="'###.###.###-##'"
            v-model="usuario.cpf"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
            label="Telefone"
            name="telefone"
            type="text"
            required
            v-mask="['(##) ####-####', '(##) #####-####']"
            v-model="usuario.telefone"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
            label="CNPJ"
            name="cnpj"
            type="text"
            required
            v-mask="'##.###.###/####-##'"
            v-model="usuario.cnpj"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
            label="Razão Social"
            name="razaosocial"
            type="text"
            required
            autocomplete="nope"
            v-model="usuario.razaoSocial"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="isFullAdmin">
        <v-col>
          <v-text-field
            label="Senha"
            name="senha"
            type="password"
            required
            autocomplete="new-password"
            v-model="usuario.senha"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col>
        <v-btn color="info" outlined text @click="maisdados = !maisdados"
          >{{ maisdados ? "Fechar " : "" }} Dados Complementares
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h2>PERMISSÕES</h2>
        <v-divider> </v-divider>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <combobox-unidade-regional
          :filter="permissao"
        ></combobox-unidade-regional>
      </v-col>
      <v-col>
        <municipio-combo
          :filter="permissao"
          @allMunicipio="(e) => (allMunicipio = e)"
        ></municipio-combo>
      </v-col>

      <v-col v-if="permissao.municipio.length">
        <app-axis-by-project-combobox :filter="permissao">
        </app-axis-by-project-combobox>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="addPermission">
          Adicionar Permissão
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="delete">
        <v-btn
          outlined
          color="error"
          class="mr-3"
          :disabled="!usuario.permissoes.length"
          @click="removeAllPermission()"
        >
          <v-icon>mdi-trash-can-outline</v-icon> Deletar Todos
        </v-btn>
        <v-btn
          outlined
          color="error"
          class="mr-3"
          :disabled="!selectionItems.length"
          @click="removePermission()"
        >
          <v-icon>mdi-trash-can-outline</v-icon> Deletar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="usuario.permissoes"
          class="elevation-1"
          ref="table"
          :items-per-page="5"
          :search="search"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-text': 'Items por página',
          }"
        >
          <template v-slot:header.selection="{ header }">
            <v-checkbox
              v-model="allSelected"
              color="primary"
              @change="
                usuario.permissoes = usuario.permissoes.map((item) => {
                  return {
                    ...item,
                    selection: !!allSelected,
                  };
                })
              "
            >
            </v-checkbox>
          </template>

          <template slot="no-data">
            <span> Nenhuma permissão encontrada </span>
          </template>

          <template v-slot:item.selection="{ item, index }">
            <v-checkbox
              color="primary"
              v-model="item.selection"
              @change="
                usuario.permissoes = usuario.permissoes.map((item, i) => {
                  if (index === i) {
                    item.selection = $event;
                  }
                  return item;
                })
              "
            >
            </v-checkbox>
          </template>

          <template v-slot:item.eixo="{ item }">
            <app-axis-by-project-combobox :filter="item">
            </app-axis-by-project-combobox>
          </template>

          <template v-slot:item.actions="{ item, index }">
            <v-btn
              outlined
              color="error"
              class="mr-3"
              @click="removeOnePermission({ item })"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>

          <template v-slot:top>
            <div style="padding: 10px">
              <h6>Filtros</h6>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquise..."
              ></v-text-field>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <modal-confirm-recover-user
      v-if="userDisabled"
      :usuario="userDisabled"
      :open="!!userDisabled"
      @onCloseModal="$router.push('/usuario')"
      @onCancelModal="userDisabled = null"
      :show-button="false"
    ></modal-confirm-recover-user>

    <v-row>
      <v-col>
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="insertUser"
          :disabled="desabilitarEnvio"
        >
          Adicionar Usuário
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { userAPI } from "./UserAPI";
import { AppGroupCombobox, AppPermissionCombobox } from "@/modules/user";
import { AppAxisByProjectCombobox } from "@/modules/axis";
import { AppCityComboboxSingle } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import MunicipioCombo from "./MunicipioCombo.vue";
import { groupsAPI } from "@/modules/groups";
import ModalConfirmRecoverUser from "./ModalConfirmRecoverUser.vue";
import { axisAPI } from "@/modules/axis";
import { emailValidatorRegex } from "@/helpers/validator";
import ComboboxUnidadeRegional from "@/modules/ur/components/Combobox.vue";

export default {
  components: {
    AppGroupCombobox,
    AppPermissionCombobox,
    AppCityComboboxSingle,
    AppAxisByProjectCombobox,
    MunicipioCombo,
    ModalConfirmRecoverUser,
    ComboboxUnidadeRegional,
  },
  data() {
    return {
      usuario: {
        habilitado: true,
        permissoes: [],
      },
      user: JSON.parse(localStorage.getItem("user")),
      search: "",
      headers: [
        { text: "", value: "selection", sortable: false, width: "5%" },
        { text: "Município", value: "municipio.nome" },
        { text: "Eixos", value: "eixo", width: "30%", sortable: false },
        { text: "Ações", value: "actions", width: "10%", sortable: false },
      ],
      userDisabled: null,
      allSelected: false,
      groupsHierarquia: [],
      permissao: {
        municipioId: null,
        municipio: [],
        permissaoId: null,
        permissao: {},
        eixoId: null,
        eixo: [],
      },
      listaEixos: [],
      emailRules: [async (v) => this.verifyEmail(v)],
      maisdados: false,
      desabilitarEnvio: false,
      emailErrors: null,
      allMunicipio: [],
    };
  },
  mounted() {
    this.getHierarquia();

    if (this.isGov) {
      this.headers = [
        { text: "", value: "selection", sortable: false, width: "5%" },
        { text: "Projeto", value: "municipio.nome" },
        { text: "Eixos", value: "eixo", width: "30%", sortable: false },
        { text: "Ações", value: "actions", width: "10%", sortable: false },
      ];
    }
  },
  watch: {
    "permissao.id_unidade_regional"(val) {
      if (val) {
        this.permissao.municipio = this.allMunicipio.filter(
          (item) => item.id_unidade_regional == val
        );
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async verifyEmail(v) {
      this.emailErrors = null;
      if (!v) {
        this.emailErrors = "Campo Obrigatório";
        return;
      }

      if (emailValidatorRegex.test(v)) {
        try {
          await userAPI.verifyEmail(v);
          this.emailErrors = null;
          return;
        } catch (error) {
          this.emailErrors = error.response.data;
          return;
        }
      }

      this.emailErrors = "Email inválido";
    },
    getHierarquia() {
      groupsAPI
        .getOne(this.user.grupoId)
        .then((resp) => {
          const { hierarquia } = resp.data;
          this.groupsHierarquia = hierarquia && JSON.parse(hierarquia);
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao achar hierarquia usuário");
        });
    },
    insertUser() {
      if (this.emailErrors) return;
      this.setLoading(true);

      let novoUsuario = [];

      this.usuario.permissoes.forEach((item) => {
        delete item.municipio.imagemMunicipioBlob;
        if (item.eixo.length > 0) {
          item.eixo.forEach((ei) => {
            novoUsuario.push({
              ...item,
              eixo: ei,
            });
          });
        } else {
          this.listaEixos.forEach((ei) => {
            novoUsuario.push({
              ...item,
              eixo: ei,
            });
          });
        }
      });

      let usuarioFinal = { ...this.usuario, permissoes: novoUsuario };

      userAPI
        .create(usuarioFinal)
        .then(({ data }) => {
          this.setLoading(false);
          if (data.message.indexOf("reabilitar") > 0) {
            this.userDisabled = data.user;
          } else if (data.message === "Usuário já cadastrado no sistema.") {
            this.$notification.error("Email já cadastrado no sistema.");
          } else {
            this.$router.push("/usuario");
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao cadastrar usuário");
        });
    },
    addPermission() {
      let multiplesMunicipios = [];
      let multiplesEixos = [];
      let multiplesMunicipiosEixos = [];

      var permissoesHash = this.usuario.permissoes.reduce((acc, curr) => {
        acc[curr.municipioId] = curr;
        return acc;
      }, {});

      if (
        this.permissao.municipio &&
        this.permissao.municipio.length &&
        this.permissao.eixo &&
        this.permissao.eixo.length
      ) {
        this.permissao.permissao = {
          nome: "Consultor Especialista",
          permissaoId: 3,
        };

        this.permissao.permissaoId = 3;

        this.permissao.municipio.forEach((item) => {
          this.permissao.municipioId = item.municipioId;
          if (!permissoesHash[item.municipioId]) {
            permissoesHash[item.municipioId] = {
              ...this.permissao,
              municipio: item,
              eixo: this.permissao.eixo,
            };
          } else {
            var eixos = this.permissao.eixo.filter((ei) =>
              permissoesHash[item.municipioId].eixo.every(
                (eixo) => ei.eixoId != eixo.eixoId
              )
            );

            permissoesHash[item.municipioId].eixo = [
              ...permissoesHash[item.municipioId].eixo,
              ...eixos,
            ];
          }
        });

        Object.values(permissoesHash).forEach((item) => {
          multiplesMunicipiosEixos.push(item);
        });

        this.usuario.permissoes = multiplesMunicipiosEixos;
      } else if (this.permissao.municipio && this.permissao.municipio.length) {
        this.permissao.permissao = {
          nome: "Consultor Especialista",
          permissaoId: 3,
        };
        this.permissao.permissaoId = 3;

        this.permissao.municipio.forEach((item) => {
          this.permissao.municipioId = item.municipioId;
          if (!permissoesHash[item.municipioId]) {
            permissoesHash[item.municipioId] = {
              ...this.permissao,
              municipioId: item.municipioId,
              municipio: item,
              eixo: [],
            };
          }
        });

        Object.values(permissoesHash).forEach((item) => {
          multiplesMunicipios.push(item);
        });

        this.usuario.permissoes = multiplesMunicipios;
      } else if (this.permissao.eixo && this.permissao.eixo.length) {
        this.permissao.permissao = null;

        if (!permissoesHash[null]) {
          permissoesHash[null] = {
            ...this.permissao,
            municipioId: null,
            municipio: [],
            eixo: this.permissao.eixo,
          };
        } else {
          var eixos = this.permissao.eixo.filter((ei) =>
            permissoesHash[null].eixo.every((eixo) => ei.eixoId != eixo.eixoId)
          );

          permissoesHash[null] = {
            ...permissoesHash[null],
            eixo: [...permissoesHash[null].eixo, ...eixos],
          };
        }

        Object.values(permissoesHash).forEach((item) => {
          multiplesEixos.push(item);
        });

        this.usuario.permissoes = multiplesEixos;
      }

      this.permissao = {
        municipioId: null,
        municipio: [],
        permissaoId: null,
        permissao: null,
        eixoId: null,
        eixo: [],
        selection: false,
      };
    },
    changePermission() {
      this.permissao.permissaoId = this.permissao.permissao.permissaoId;
    },
    getEixos() {
      axisAPI
        .list()
        .then((resp) => {
          this.listaEixos = resp.data;
        })
        .catch();
    },
    removePermission() {
      this.usuario.permissoes = this.notSelectionItems;
    },
    removeAllPermission() {
      this.usuario.permissoes = [];
    },
    removeOnePermission({ item }) {
      this.usuario.permissoes.forEach((val, index) => {
        if (item == val) {
          this.usuario.permissoes.splice(index, 1);
        }
      });
    },
    changeCity() {
      this.permissao.municipioId = this.permissao.municipio.municipioId;
      this.permissao.projetoId = this.permissao.municipio.projetoId;
    },
    loadUser() {
      this.setLoading(true);
      userAPI
        .getByCPF(this.usuario.cpf)
        .then((resp) => {
          if (resp.data.usuarioId) {
            this.$notification.error(
              "Já existe um usuário cadastrado com este CPF!"
            );
            this.desabilitarEnvio = true;
          } else {
            this.desabilitarEnvio = false;
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao buscar usuário");
        });
    },
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isGov"]),
    selectionItems() {
      return this.usuario.permissoes.filter((item) => item.selection);
    },
    notSelectionItems() {
      return this.usuario.permissoes.filter((item) => !item.selection);
    },
  },
};
</script>
